// extracted by mini-css-extract-plugin
export default {"root":"d429pPKiv5m8u3E96rhx","body":"X0O6v8kifOJmLAn6vZnc","modal":"cInrxoC4LIug_Fak66FU","btn":"GaSXQ3FIE6dbKTzKcZse","btns":"tO_kqy_EwgVr8zO8lOp5","message":"wjStYJ8qXdGHcEM8jMmg"};